import {Component, Inject} from '@angular/core';
import { IonicPage } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';
import {EnvVariables} from "../../../envioronment-variables/environment-variables.token";


@IonicPage({
    segment: 'faq',
    name: 'FaqPage'
})
@Component({
    selector: 'page-faq',
    templateUrl: 'faq.html',
})
export class FaqPage {

    public urlFaq;

    constructor(
        public sanitizer: DomSanitizer,
        @Inject(EnvVariables) public envVariables
    ) {
        this.urlFaq = this.sanitizer.bypassSecurityTrustResourceUrl(this.envVariables.faqUrl);

    }


}



// WEBPACK FOOTER //
// ./src/pages/faq/faq.ts